import gql from 'graphql-tag';

const EVENTS_TARGETS = gql`
  query eventsTargets($where: EventsTargetWhereInput!) {
    eventsTargets(where: $where) {
      id
      name
      eventTags {
        appId
      }
      cart
      tag
      pageViews
      total
      signups
      sessions
      transactions
      impressions
      basketItems
      tagUpdateDate
      testLogs {
        id
        testDate
        pageViews
        signups
        total
        transactions
        basketItems
        sessions
        impressions
      }
      isSignUps
      isCommerce
      isAdvertiser
      type
      orgs {
        id
        name
        website
      }
      createdAt
    }
  }
`;

export default EVENTS_TARGETS;
